import EventEmitter from 'eventemitter3';

// Game specific events
export interface IGameEvents {
    NEW_GAME: () => void;
    CONTEXT_LOST: () => void;
    CONTEXT_RESTORED: () => void;
}

export type TCombinedEvents = IGameEvents;

export class GameEventEmitter extends EventEmitter<TCombinedEvents> {}
export const gameEventEmitter = new GameEventEmitter();
